import type { FileRoutesByTo } from "@/routeTree.gen";

import {
	Sidebar,
	SidebarContent,
	SidebarHeader,
	SidebarRail,
	useSidebar
} from "@/components/ui/sidebar";
import { cn } from "@/lib/utils";

import { CompanyHeader } from "./nav-header";
import { NavMain } from "./nav-main";
import { NavSecondary } from "./nav-secondary";

export interface SidebarItem {
	title: string;

	url: keyof FileRoutesByTo | string;
	icon: React.ElementType;
	isActive?: boolean;
	hasPushNotifications?: boolean;
	items?: Omit<SidebarItem, "icon" | "hasPushNotifications">[];
}

export interface AppSidebarProps {
	navMain: SidebarItem[][];
	navSecondary: SidebarItem[];
}

export function AppSidebar({
	data,
	...props
}: { data: AppSidebarProps } & React.ComponentProps<typeof Sidebar>) {
	const { state } = useSidebar();
	return (
		<Sidebar
			className={cn("bg-[#2A2A2A] *:text-white", {
				"p-3": state === "expanded"
			})}
			collapsible="icon"
			{...props}
		>
			<SidebarHeader>
				<CompanyHeader />
			</SidebarHeader>
			<SidebarContent className="overflow-hidden">
				<NavMain items={data.navMain} />
				{/* <NavMain items={test.navMain} /> */}
			</SidebarContent>
			<NavSecondary className="mt-auto" items={data.navSecondary} />
			<SidebarRail />
		</Sidebar>
	);
}
